import { defineMessages } from 'react-intl';

export default defineMessages({
  errorHeader: 'Something went wrong.',
  errorMessage: 'Please try again later.',
});
